module.exports = __webpack_public_path__ + "img/01.88aeadd3.png";